import * as Yup from 'yup';

import { Strings } from '@app/constants';

export const bankInformationSchema = Yup.object().shape({
  bankInfo: Yup.object().shape({
    bankInformation: Yup.object().shape({
      accountHolderName: Yup.string().required(
        Strings.validation.fieldRequired(Strings.field.accountHolderName)
      ),
      fatherName: Yup.string().required(Strings.validation.fieldRequired(Strings.field.fatherName)),
      bankName: Yup.string().required(Strings.validation.fieldRequired(Strings.field.bankName)),
      ifscCode: Yup.string().required(Strings.validation.fieldRequired(Strings.field.ifsc)),
      accountType: Yup.string().required(
        Strings.validation.fieldRequired(Strings.field.accountType)
      ),
      accountNumber: Yup.number()
        .required(Strings.validation.fieldRequired(Strings.field.accountNumber))
        .min(10000)
        .integer()
        .typeError(Strings.validation.invalidAccountNumber),
      reenterAccountNumber: Yup.number()
        .required(Strings.validation.fieldRequired(Strings.field.reenterAccountNumber))
        .oneOf([Yup.ref('accountNumber')], Strings.validation.accountNumberNotMatch)
        .integer(),
    }),
  }),
});

// --------------educationInformation-Schema-----------------

export const educationInformationSchema = Yup.object()
  .shape({
    educationInfo: Yup.object().shape({
      education: Yup.array().of(
        Yup.object().shape({
          name: Yup.string().required(Strings.validation.fieldRequired(Strings.field.name)),
          degree: Yup.string().required(Strings.validation.fieldRequired(Strings.education.degree)),
          passedOutYear: Yup.string().required(
            Strings.validation.fieldRequired(Strings.education.passedOutYear)
          ),
          specialization: Yup.string().required(Strings.education.specialization),
        })
      ),
    }),
  })
  .required();

// --------------DocumentInformation-Schema-----------------

export const documentInformationSchema = Yup.object()
  .shape({
    documentInfo: Yup.object().shape({
      aadharFront: Yup.mixed().required(
        Strings.validation.uploadRequired(Strings.document.aadharCardFront)
      ),
      aadharBack: Yup.mixed().required(
        Strings.validation.uploadRequired(Strings.document.aadharCardBack)
      ),
      panFront: Yup.mixed().required(
        Strings.validation.uploadRequired(Strings.document.panCardFront)
      ),
      panBack: Yup.mixed().required(
        Strings.validation.uploadRequired(Strings.document.panCardBack)
      ),
    }),
  })
  .required();

// --------------GeneralInformation-Schema-----------------

export const generalInformationSchema = Yup.object()
  .shape({
    firstName: Yup.string().required(Strings.validation.fieldRequired(Strings.field.firstName)),

    lastName: Yup.string().required(Strings.validation.fieldRequired(Strings.field.lastName)),

    mobileNumber: Yup.string()
      .trim()
      .required(Strings.validation.fieldRequired(Strings.field.mobileNumber))
      .matches(
        /^(?:(?:\+|0{0,2})91(\s*[-]\s*)?|[0]?)?[6789]\d{9}$/,
        Strings.validation.invalidMobileNumber
      ),
    aboutMe: Yup.string().required(Strings.validation.fieldRequired(Strings.addEmployee.aboutMe)),

    personalEmail: Yup.string()
      .required(Strings.validation.fieldRequired(Strings.field.personalEmail))
      .email(Strings.validation.invalidEmail),
    gender: Yup.string().required(Strings.validation.fieldRequired(Strings.field.gender)),
    maritalStatus: Yup.string().required(
      Strings.validation.fieldRequired(Strings.field.maritalStatus)
    ),

    permanentAddress: Yup.object().shape({
      address: Yup.string().required(
        Strings.validation.fieldRequired(Strings.addEmployee.addressLine1)
      ),
      addressLine2: Yup.string().required(
        Strings.validation.fieldRequired(Strings.addEmployee.addressLine2)
      ),
      city: Yup.string().required(Strings.validation.fieldRequired(Strings.addEmployee.city)),
      state: Yup.string().required(Strings.validation.fieldRequired(Strings.addEmployee.state)),
      country: Yup.string().required(Strings.validation.fieldRequired(Strings.addEmployee.country)),
      postalCode: Yup.string().required(
        Strings.validation.fieldRequired(Strings.addEmployee.postalCode)
      ),
    }),
    presentAddress: Yup.object().shape({
      address: Yup.string().required(
        Strings.validation.fieldRequired(Strings.addEmployee.addressLine1)
      ),
      addressLine2: Yup.string().required(
        Strings.validation.fieldRequired(Strings.addEmployee.addressLine2)
      ),
      city: Yup.string().required(Strings.validation.fieldRequired(Strings.addEmployee.city)),
      state: Yup.string().required(Strings.validation.fieldRequired(Strings.addEmployee.state)),
      country: Yup.string().required(Strings.validation.fieldRequired(Strings.addEmployee.country)),
      postalCode: Yup.string().required(
        Strings.validation.fieldRequired(Strings.addEmployee.postalCode)
      ),
    }),

    emergencyContactInfo: Yup.object().shape({
      emergencyContact: Yup.array().of(
        Yup.object().shape({
          name: Yup.string().required(Strings.validation.fieldRequired(Strings.addEmployee.name)),
          relation: Yup.string().required(
            Strings.validation.fieldRequired(Strings.addEmployee.relation)
          ),
          phone: Yup.string()
            .required(Strings.validation.fieldRequired(Strings.addEmployee.phone))
            .matches(/^\d{10}$/, Strings.validation.invalidMobileNumber),
        })
      ),
    }),
  })
  .required();
